import React from 'react';
import { UserCircleIcon, IdentificationBadgeIcon, ChevronRightIcon } from '@fronton/icons-react';
import { B2B_PERSONAL_ACCOUNT_HOST } from 'common/constants/header-constants';
import { WithAuthProps, withAuth } from 'components/header-legacy/hoc';
import { useAuthLogic } from 'components/header/hooks/auth';
import { UserMenuItem } from '../profile/components/user/user-menu-item';
import { WithLoginB2B } from '../profile';

export interface EntryUserMenuProps extends WithAuthProps, WithLoginB2B {
  loginPageUrl: string;
}

export const EntryUserMenuBase = ({ loginPageUrl, login, loginB2B }: EntryUserMenuProps) => (
  <>
    <UserMenuItem
      icon={UserCircleIcon}
      rightIcon={ChevronRightIcon}
      data-qa="signin-lk"
      href={loginPageUrl}
      onClick={login}>
      Личный аккаунт
    </UserMenuItem>

    <UserMenuItem
      onClick={loginB2B}
      icon={IdentificationBadgeIcon}
      rightIcon={ChevronRightIcon}
      data-qa="signin-lk-b2b"
      href={B2B_PERSONAL_ACCOUNT_HOST}>
      Бизнес-аккаунт
    </UserMenuItem>
  </>
);

export const EntryUserMenu = withAuth<EntryUserMenuProps, WithAuthProps & WithLoginB2B>(
  EntryUserMenuBase,
  useAuthLogic
);
